import { useSetAtom } from "jotai";
import type { FunctionComponent } from "react";
import { startTransition } from "react";

import { useEditionValue } from "shared/lib/edition";
import { yieldToMain } from "shared/lib/utils";

import { hamburgerMenuAtom } from "scmp-app/components/hamburger-menu/atoms";
import type { ShowInVariant } from "scmp-app/components/header/features/styles";
import { sendGA4Tracking } from "scmp-app/components/tracking/google-analytics-4/apis";

import IconMenu from "./menu.svg";
import { IconMenuContainer } from "./styles";

export type HeaderFeaturesHamburgerMenuProps = {
  showIn?: ShowInVariant;
};

export const HeaderFeaturesHamburgerMenu: FunctionComponent<HeaderFeaturesHamburgerMenuProps> = ({
  showIn,
}) => {
  const setHamburgerMenuState = useSetAtom(hamburgerMenuAtom);
  const edition = useEditionValue();

  return (
    <IconMenuContainer
      $showIn={showIn}
      onClick={() => {
        void (async () => {
          await yieldToMain({ priority: "user-blocking" });
          startTransition(() => {
            setHamburgerMenuState(current => ({
              ...current,
              isOpen: !current.isOpen,
            }));
          });
        })();

        void (async () => {
          await yieldToMain({ priority: "background" });
          sendGA4Tracking({
            action: "click",
            category: "menu",
            customized_parameters: {
              action_type: "open",
              edition,
              menu_type: "hamburger",
            },
            subcategory: "section",
          });
        })();
      }}
    >
      <IconMenu />
    </IconMenuContainer>
  );
};

HeaderFeaturesHamburgerMenu.displayName = "HeaderFeaturesHamburgerMenu";
